import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { CommitmentSection } from './components/CommitmentSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Kingsbury Maintenance & Construction';
  }, []);
  return <div className="min-h-screen bg-white font-sans text-body selection:bg-primary/20 selection:text-charcoal" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <WhyChooseUs data-id="element-6" />
        <CommitmentSection data-id="element-7" />
        <ContactSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}